import React from 'react'
import PropTypes from 'prop-types'

import ProductsTableLayout from '../ProductsTableLayout'

const PassesList = (props) =>
    <ProductsTableLayout
        noDataText="Offer different levels of limited-time access to content"
        type="pass"
        {...props}
    />

PassesList.propTypes = {
    items: PropTypes.array,
    loading: PropTypes.bool,
}

export default PassesList
